import React, { useEffect, useState } from "react";
import { Button, TextField, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CountryDialCodeSelect from "~/components/common/CountryDialCodeSelect";
import Utils from "~/helpers/Utils";
import checkoutServices from "~/services/checkoutServices";
import userUpdateService from "~/services/userUpdateService";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import { getCountryCode as getIsoFromPrefix } from "~/helpers/countriesHelper";

export default function DialogPhoneNumber({ 
  onClose, 
  titleKey = "Complete your phone", 
  messageKey = "You logged in with Google We need your number to send confirmations via WhatsApp" 
}) {
  const { t } = useTranslation();
  const { business } = useSelector((store) => store?.business);
  const { me: meStore } = useSelector((store) => store?.me);
  const meData = Utils.safeParseJSON("@prit-web/meData", meStore);
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("BR");
  const [ddiIndex, setPhoneDdiIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (business?.phone) {
      const idx = Utils.phoneDdiIndex(business.phone);
      setPhoneDdiIndex(idx);
    } else {
      // Inicializa com Brasil (índice 0) se não houver telefone
      setPhoneDdiIndex(0);
      setCountry("BR");
    }
  }, [business?.phone]);

  useEffect(() => {
    const current = Utils.ddis[ddiIndex];
    if (!current) {
      // Se não houver DDI válido, define Brasil como padrão
      setCountry("BR");
      return;
    }

    const isoFromPrefix = getIsoFromPrefix(current.prefix);
    if (isoFromPrefix) {
      setCountry(isoFromPrefix.toUpperCase());
    } else {
      const ddiDigits = (current.ddi || "").replace(/\D/g, "");
      const match = getCountries().find((c) => String(getCountryCallingCode(c)) === ddiDigits);
      if (match) {
        setCountry(match.toUpperCase());
      } else {
        // Fallback para Brasil se não encontrar correspondência
        setCountry("BR");
      }
    }
  }, [ddiIndex]);

  const submitForm = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const userIdStorage = localStorage.getItem("@prit-web/userId");
      let unmaskedPhone = phone.replace(/\D/g, "");
      unmaskedPhone = `${Utils.ddis[ddiIndex].ddi}${unmaskedPhone}`;

      await userUpdateService.pachUserUpdate(userIdStorage || meData?.id || meStore?.id, {
        phoneUnverified: unmaskedPhone,
      });

      const res = await checkoutServices.me();
      if (res?.data?.id) {
        localStorage.setItem("@prit-web/meData", JSON.stringify(res.data));
        localStorage.setItem("@prit-web/userId", res.data.id);
      }

      if (typeof onClose === "function") onClose();
    } catch (error) {
      alert(
        `${t("There was an error saving your phone number")}: ${
          error?.response?.data?.message || error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "0 16px 16px 16px", maxWidth: 480, margin: "0 auto" }}>
      <Typography style={{ fontWeight: 700, fontSize: 24, textAlign: "center", marginBottom: 12, color: "#222" }}>
        {t(titleKey)}
      </Typography>

      <Typography style={{ fontSize: 14, textAlign: "left", color: "#666", marginBottom: 24, lineHeight: 1.5 }}>
        {t(messageKey)}
      </Typography>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 8,
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "4px 12px",
        }}
      >
        <CountryDialCodeSelect
          valueISO2={country}
          onChange={({ dialCode, iso2 }) => {
            setCountry(iso2);
            const foundIndex = Utils.ddis.findIndex((item) => item.ddi === dialCode);
            if (foundIndex !== -1) {
              setPhoneDdiIndex(foundIndex);
              setPhone("");
            }
          }}
          width={"auto"}
        />

        <TextField
          value={phone}
          onChange={(e) => {
            const ev = { target: { value: e.target.value } };
            const prefix = Utils.ddis[ddiIndex]?.prefix || Utils.ddis[0]?.prefix || "BRA";
            Utils.telephoneMask(ev, prefix);
            setPhone(ev.target.value);
          }}
          placeholder={t("Enter your phone")}
          fullWidth
          inputProps={{ maxLength: Utils.ddis[ddiIndex]?.pattern?.maxLength || 15 }}
          style={{
            height: "44px",
            flex: 1,
          }}
          InputProps={{
            style: { border: "none" },
          }}
        />
      </div>

      <Button
        onClick={submitForm}
        disabled={phone.replace(/\D/g, "").length < (Utils.ddis[ddiIndex]?.maxLength || 10) || loading}
        style={{
          width: "100%",
          marginTop: 16,
          backgroundColor:
            phone.replace(/\D/g, "").length < (Utils.ddis[ddiIndex]?.maxLength || 10)
              ? "#dddddd"
              : "#3f51b5",
          color: "#fff",
          textTransform: "none",
          fontWeight: 600,
          padding: "12px",
          borderRadius: "30px",
          fontSize: "16px",
        }}
      >
        {t("Save phone")}
      </Button>
    </div>
  );
}
